module.exports = __webpack_public_path__ + "static/media/no_followings.3d0cc0bd.png";